import { Assets, Texture } from 'pixi.js';

/**
 * Caricamento degli asset grafici CraftPix ("Top-Down Simple Summer" per il
 * mondo, "Monster Creature Pack" per i battler — vedi docs/CREDITS.md).
 * Terreno: 56 tile 256×256 con transizioni sabbia/erba già disegnate.
 * Props: alberi, cespugli, rocce, casa, torre magica come sprite singoli.
 */

export function assetUrl(path: string): string {
  return `${import.meta.env.BASE_URL}assets/${path}`;
}

export const PROP_IDS = [
  'tree-small',
  'tree-medium',
  'tree-large',
  'bush-small',
  'bush-medium',
  'bush-large',
  'rock-1',
  'rock-2',
  'rock-3',
  'rock-4',
  'rock-5',
  'house',
  'magic-tower',
  'well',
] as const;

export type PropId = (typeof PROP_IDS)[number];

export interface GameAssets {
  /** Tile del terreno indicizzati per numero (1..56). */
  ground: Map<number, Texture>;
  props: Map<PropId, Texture>;
}

export async function loadGameAssets(groundIds: number[]): Promise<GameAssets> {
  const urls: string[] = [];
  const groundUrl = new Map<number, string>();
  for (const id of new Set(groundIds)) {
    const url = assetUrl(`ground/${id}.png`);
    groundUrl.set(id, url);
    urls.push(url);
  }
  const propUrl = new Map<PropId, string>();
  for (const id of PROP_IDS) {
    const url = assetUrl(`props/${id}.png`);
    propUrl.set(id, url);
    urls.push(url);
  }

  const loaded = await Assets.load<Texture>(urls);

  const ground = new Map<number, Texture>();
  for (const [id, url] of groundUrl) ground.set(id, loaded[url]!);
  const props = new Map<PropId, Texture>();
  for (const [id, url] of propUrl) props.set(id, loaded[url]!);
  return { ground, props };
}
